import Image from 'UIKit/Image'
import MarqueeCarousel from 'UIKit/MarqueeCarousel'
import Skeleton from 'UIKit/Skeleton'
import useMatchBreakpoints from 'hooks/useMatchBreakpoints'
import { RowCenter } from 'layout/Components/Row'
import React, { memo } from 'react'
import styled from 'styled-components'
import theme from 'theme'
import getExternalLinkProps from 'utils/getExternalLinkProps'
import { HunnyPartner as HunnyPartnerType } from './type'
import { useHunnyPartner } from './useHunnyPartner'

const ItemPartner = ({ partner }: { partner: HunnyPartnerType }) => {
  const { isMobile } = useMatchBreakpoints()

  return (
    <RowCenter
      width="100%"
      key={`partner-${partner.id}`}
      id={partner.id}
      as="a"
      aria-label={partner.id}
      href={partner.url}
      target={partner.target}
      {...getExternalLinkProps()}
    >
      <StyledImage
        width={400}
        height={48}
        src={isMobile ? partner.mobileImageSrc : partner.imageSrc}
        alt={partner.alt}
      />
    </RowCenter>
  )
}
const SPEED_PER_ITEM_DESKTOP = 3
const SPEED_PER_ITEM_MOBILE = 2.6

const HunnyPartner: React.FC = () => {
  const { partners, isLoading } = useHunnyPartner()
  const { isMobile } = useMatchBreakpoints()

  return (
    <StyledNav id="partner">
      {isLoading ? (
        <Skeleton width="100%" height={['32px', '', '', '', '48px']} />
      ) : partners?.length > 0 ? (
        <StyledWrapPartner>
          <MarqueeCarousel
            items={partners?.map((partner) => (
              <ItemPartner partner={partner} />
            ))}
            speedPerItem={isMobile ? SPEED_PER_ITEM_MOBILE : SPEED_PER_ITEM_DESKTOP}
            gap={theme.spacing.fix_500}
          />
        </StyledWrapPartner>
      ) : null}
    </StyledNav>
  )
}

const StyledImage = styled(Image)`
  width: 100%;

  img {
    height: 32px;
    object-fit: contain;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    img {
      height: 48px;
    }
  }
`

const StyledNav = styled.nav`
  width: 100%;
`

const StyledWrapPartner = styled(RowCenter)`
  padding: ${({ theme }) => theme.spacing.fix_200} 0;
  border-top: 1px;
  border-bottom: 1px;
  border-style: solid;
  border-color: ${({ theme }) => theme.colors.buttonBackgroundAlt2};
  opacity: 0.8;
  width: 100%;
`

HunnyPartner.displayName = 'HunnyPartner'
export default memo(HunnyPartner)
